import * as React from 'react'
import { useMatch } from 'react-router-dom'

import { Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import {
  historicChangesTranslations,
  statusTranslation,
} from 'modules/bookkeepers/lib/dynamicTranslations'
import { useInhousePayroll } from 'modules/payroll_bundle/hooks/useInhousePayroll'
import type { IncidenceChangeItem, IncidenceChangeValue } from 'modules/payroll_bundle/lib/types'

interface Props {
  currentValue?: IncidenceChangeValue
  change: IncidenceChangeItem
}

const IncidenceStatusItem = ({ change, currentValue }: Props) => {
  const { navigation } = useNavigation()

  const author = change.changedBy
  const currentFieldValue = currentValue?.value ? `${currentValue.value}` : ''
  const isBookkeeperView = !!useMatch({ path: navigation.bookkeepers.fullPath(), end: false })
  const { hasInhousePayroll } = useInhousePayroll()

  return (
    <>
      <Text.Normal size="300" weight="medium">
        {historicChangesTranslations(change.id)}
        &nbsp;
        {!!currentFieldValue &&
          statusTranslation(currentFieldValue, isBookkeeperView, hasInhousePayroll)}
      </Text.Normal>
      <Text.Normal size="100" weight="normal">
        {i18n.t('bookkeepers.incidence.incidence_status_text.by_text', { author })}
      </Text.Normal>
    </>
  )
}

export default IncidenceStatusItem
